<template>
  <div class="pointDetail">
    <div>
      <markbox :item="list"></markbox>
      <div class="intes-bt">
        {{ list.name }}修复能力为：<b>{{ list.status }}</b>
      </div>
      <div class="bgBoxtit">
        肠动力动态趋势图
        <ul>
          <li>
            <span></span>
            减弱
          </li>
          <li>
            <span></span>
            普通
          </li>
          <li>
            <span></span>
            加强
          </li>
        </ul>
      </div>
      <div class="bgBoxtb">
        <echarts-bar :barlist="list.echartsList"></echarts-bar>
      </div>
      <div class="intes-cjfx">
        <div>
          <h3>常见风险</h3>
          <p v-html="list.remakrs"></p>
        </div>
        <div>
          <h3>健康管理建议</h3>
          <p v-html="list.exam_references"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import markbox from "./markBox.vue"
import EchartsBar from './EchartsBar'
export default {
  props: ['list'],
  components: { markbox, EchartsBar },
  data () {
    return {
      risklist: []
    }
  },
  watch: {
    list (newVal) {
      this.list = newVal;
    }
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.intes-bt {
  padding: 24px 20px;
  font-size: 28px;
  color: #666;
  border-bottom: 2px solid #d3e2ef;
  margin-bottom: 20px;
}
.bgBoxtit {
  padding: 0 20px;
}
.bgBoxtb {
  margin-top: -40px;
}
.intes-bt1 {
  padding: 24px 20px 0px 20px;
  font-size: 24px;
  color: #666;
}
.intes-cjfx {
  padding: 30px;

  background: #f4faff;
  font-size: 26px;
  div {
    margin-bottom: 30px;
  }
  div:last-child {
    margin-bottom: 0;
  }
  h3 {
    color: #3195e6;
    margin: 0;
  }
  p {
    color: #333;
    margin: 0;
  }
}
</style>